export const loading = state => state.apiReducer.loading
